import "../css/AboutUs.css";

export default function AboutUs() {
  const stats = [
    {
      number: "25+",
      label: "Partner Schools",
      accent: "yellow",
    },
    {
      number: "10,000+",
      label: "Students Impacted",
      accent: "blue",
    },
    {
      number: "75+",
      label: "Live Projects",
      accent: "purple",
    },
  ];

  return (
    <main className="ms-about-page">
      {/* =====================================================
          HERO
      ===================================================== */}

      <section className="ms-about-hero">
        <div className="ms-about-grid-bg" />

        <div className="ms-about-glow ms-about-glow-blue" />
        <div className="ms-about-glow ms-about-glow-yellow" />

        <div className="ms-about-container">
          <div className="ms-about-hero-layout">
            {/* ===============================================
                LEFT
            =============================================== */}

            <div className="ms-about-hero-copy">
              <div className="ms-about-kicker">
                <span />

                ABOUT MINDSPARK
              </div>

              <h1>
                Transforming education through
                <span> real-time projects.</span>
              </h1>

              <p>
                We help schools empower students with
                embedded, hands-on, real-world learning
                experiences.
              </p>

              <div className="ms-about-brand-message">
                <div className="ms-about-brand-icon">
                  <span />
                  <span />
                </div>

                <div>
                  <small>
                    OUR APPROACH
                  </small>

                  <strong>
                    Learning Through Technology
                  </strong>
                </div>
              </div>
            </div>

            {/* ===============================================
                MOVING TECHNOLOGY ORBIT
            =============================================== */}

            <div className="ms-about-visual">
              <div
                className="ms-about-orbit"
                aria-label="MindSpark learning areas: Robotics, Artificial Intelligence, Coding and STEM"
              >
                {/* PULSING RINGS */}
                <div className="ms-about-orbit-ring ring-one" />
                <div className="ms-about-orbit-ring ring-two" />
                <div className="ms-about-orbit-ring ring-three" />

                {/* CENTER */}
                <div className="ms-about-center-mark">
                  <div className="ms-center-shape">
                    <span />
                    <span />
                  </div>

                  <strong>
                    MindSpark
                  </strong>

                  <small>
                    EduTech
                  </small>
                </div>

                {/* MOVING ITEMS */}
                <div className="ms-about-orbit-item robotics">
                  <span />
                  Robotics
                </div>

                <div className="ms-about-orbit-item ai">
                  <span />
                  AI
                </div>

                <div className="ms-about-orbit-item coding">
                  <span />
                  Coding
                </div>

                <div className="ms-about-orbit-item stem">
                  <span />
                  STEM
                </div>
              </div>
            </div>
          </div>

          {/* ===============================================
              STATS
          =============================================== */}

          <div className="ms-about-stats">
            {stats.map((stat, index) => (
              <article
                key={stat.label}
                className={`ms-about-stat ${stat.accent}`}
              >
                <span className="ms-about-stat-index">
                  {String(index + 1).padStart(2, "0")}
                </span>

                <strong>
                  {stat.number}
                </strong>

                <p>
                  {stat.label}
                </p>

                <div className="ms-about-stat-line" />
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* =====================================================
          COMPANY STORY
      ===================================================== */}

      <section className="ms-about-story-section">
        <div className="ms-about-container">
          <div className="ms-about-section-heading">
            <div className="ms-about-kicker">
              <span />

              OUR STORY
            </div>

            <h2>
              Education that moves from
              <span> learning to doing.</span>
            </h2>

            <p>
              MindSpark brings practical technology
              experiences into school education so students
              can understand concepts by applying them.
            </p>
          </div>

          <div className="ms-about-story-grid">
            {/* =================================================
                WHO WE ARE
            ================================================= */}

            <article className="ms-about-card ms-about-card-who">
              <div className="ms-about-card-number">
                01
              </div>

              <div className="ms-about-card-icon blue">
                <svg
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <circle
                    cx="12"
                    cy="12"
                    r="8"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.7"
                  />

                  <path
                    d="M8 13.5c1.2 1.3 2.5 2 4 2s2.8-.7 4-2M9 9.5h.01M15 9.5h.01"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                  />
                </svg>
              </div>

              <span className="ms-about-card-label">
                WHO WE ARE
              </span>

              <h3>
                An EdTech platform built around practical
                learning.
              </h3>

              <p>
                We are an EdTech platform designed to
                seamlessly integrate real-time,
                project-based learning into school
                education. Our solutions align with
                academic goals while building practical
                skills.
              </p>

              <div className="ms-about-card-accent" />
            </article>

            {/* =================================================
                WHAT MAKES US DIFFERENT
            ================================================= */}

            <article className="ms-about-card ms-about-card-different">
              <div className="ms-about-card-number">
                02
              </div>

              <div className="ms-about-card-icon yellow">
                <svg
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path
                    d="M5 12h14M12 5v14M7.5 7.5l9 9M16.5 7.5l-9 9"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.6"
                    strokeLinecap="round"
                  />

                  <circle
                    cx="12"
                    cy="12"
                    r="7.5"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.4"
                  />
                </svg>
              </div>

              <span className="ms-about-card-label">
                WHAT MAKES US DIFFERENT
              </span>

              <h3>
                Projects are part of learning — not an
                afterthought.
              </h3>

              <p>
                Our projects are embedded directly into
                classroom learning, ensuring students don’t
                just learn concepts—but apply them in
                real-world scenarios from an early stage.
              </p>

              <div className="ms-about-different-footer">
                <span>
                  Understand
                </span>

                <i>→</i>

                <span>
                  Build
                </span>

                <i>→</i>

                <span>
                  Apply
                </span>
              </div>
            </article>

            {/* =================================================
                WHAT WE OFFER
            ================================================= */}

            <article className="ms-about-card ms-about-card-offer">
              <div className="ms-about-card-number">
                03
              </div>

              <div className="ms-about-card-icon purple">
                <svg
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path
                    d="M5 6h14M5 12h14M5 18h14"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                  />

                  <circle
                    cx="8"
                    cy="6"
                    r="1.5"
                    fill="currentColor"
                  />

                  <circle
                    cx="15"
                    cy="12"
                    r="1.5"
                    fill="currentColor"
                  />

                  <circle
                    cx="10"
                    cy="18"
                    r="1.5"
                    fill="currentColor"
                  />
                </svg>
              </div>

              <span className="ms-about-card-label">
                WHAT WE OFFER
              </span>

              <h3>
                Learning experiences designed for schools.
              </h3>

              <ul className="ms-about-offer-list">
                <li>
                  <span>01</span>

                  Embedded curriculum-based projects
                </li>

                <li>
                  <span>02</span>

                  Real-time guided learning experiences
                </li>

                <li>
                  <span>03</span>

                  Skill-focused student development
                </li>

                <li>
                  <span>04</span>

                  School-ready implementation models
                </li>
              </ul>
            </article>

            {/* =================================================
                VISION
            ================================================= */}

            <article className="ms-about-card ms-about-card-vision">
              <div className="ms-about-card-number">
                04
              </div>

              <div className="ms-about-card-icon teal">
                <svg
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path
                    d="M3 12s3.5-6 9-6 9 6 9 6-3.5 6-9 6-9-6-9-6Z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.7"
                  />

                  <circle
                    cx="12"
                    cy="12"
                    r="2.5"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.7"
                  />
                </svg>
              </div>

              <span className="ms-about-card-label">
                OUR VISION
              </span>

              <h3>
                A future where students learn by creating.
              </h3>

              <p>
                To create a future where every student
                learns by building, experimenting, and
                solving real problems—not just memorizing
                content.
              </p>

              <div className="ms-about-vision-message">
                Learning becomes powerful when students
                experience it.
              </div>
            </article>
          </div>
        </div>
      </section>

      {/* =====================================================
          CLOSING
      ===================================================== */}

      <section className="ms-about-closing">
        <div className="ms-about-container">
          <div className="ms-about-closing-content">
            <small>
              MINDSPARK EDUTECH
            </small>

            <h2>
              Building curiosity. Creating confidence.
              <span> Learning through technology.</span>
            </h2>
          </div>

          <div className="ms-about-closing-tags">
            <span className="yellow">
              Robotics
            </span>

            <span className="purple">
              AI
            </span>

            <span className="blue">
              Coding
            </span>

            <span className="teal">
              STEM
            </span>
          </div>
        </div>
      </section>
    </main>
  );
}
